export interface AlkaliProps {
  Concentration: number;
  ['Material A']: string;
  ['Mol. Weight']: number;
  Stoichiometry: number;
  Formula: string;
}

export interface SelectProps {
  value: string;
  label: string;
}

export interface ProspectProps {
  assignedUsersCount: number;
  id: number;
  modifiedProspectsCount: number;
  prospectsCount: number;
  title: string;
  uploadDate: string;
}

export interface SoilProps {
  CEC: number;
  Country: string;
  Soils: string;
  pHImprovements: string;
  pHMaintenance: string | null;
}

export interface EfficiencyProps {
  CAP: number;
  pH: number;
  ['S/CEC']: string;
}

export interface MineralizationProps {
  Country: string;
  NRate: string;
  P2O5Rate: string;
  SO3Rate: string;
  NPrice: number;
  P2O5Price: number;
  K2OPrice: number;
  SO3Price: number;
}

export interface CropProps {
  Country: string;
  CropRotationReminder: string;
  Crops: string;
  EquationYeildLosses: string;
  GroupYeildLosses: number;
  GroupYeildOptimumPH: number;
  PotentialYeild: number;
  Price: number;
  YeildLossesCurrentPH: string;
  YeildLossesCurrentTargetPH: string;
  YeildLossesTargetPH: string;
}

export interface ProductsProps {
  CAP: number;
  NV: number;
  Price: number;
  Country: string;
  Products: string;
}

export interface ProspectOneProps {
  applications: string;
  companyName: string;
  contact: string;
  contactNumber: string;
  id: number;
  industry: string;
  isModified: boolean;
  latitude: string;
  longtitude: string;
  rating: string;
  status: string;
  updatedAt: string;
}

export interface DatasetByIdProps {
  assignedUsers: {
    blueLang: string;
    createdAt: string;
    greenLang: string;
    id: number;
    lastName: string;
    organization: string;
    title: string;
    updatedAt: string;
  }[];
  id: number;
  title: string;
  uploadDate: string;
  prospects: {
    applications: string;
    companyName: string;
    contact: string;
    contactNumber: string;
    id: number;
    industry: string;
    isModified: boolean;
    latitude: string;
    longtitude: string;
    rating: string;
    status: string;
    updatedAt: string;
  }[];
}

export interface BriefProps {
  ['Additional optional benefits']: string | null;
  ['Additional optional benefits2']: string | null;
  ['Additional optional benefits3']: string | null;
  ['Additional optional benefits4']: string | null;
  ['Additional optional benefits5']: string | null;
  ['Additional optional benefits6']: string | null;
  Application: string;
  ['Application Code']: number;
  Industry: string;
  ['Indutry Code']: number;
  ['Product benefits1']: string | null;
  ['Product benefits2']: string | null;
  ['Product benefits3']: string | null;
  ['Product benefits4']: string | null;
  ['Product benefits5']: string | null;
  ['Product benefits6']: string | null;
  ['Product description']: string;
  ['Product recommendation']: string;
  ['Product recommendation order']: number;
  ['Project Brief Code']: number;
  ['Sub-Industry']: string;
  ['Sub-industry Code']: number;
}

export interface CropTableProps {
  id: number;
  name: string;
  yield: number;
  price: number;
  phIfNoLim: number;
  limiting: string;
  expectPh: string;
  yieldPercent: string;
  yieldPrice: number;
  n: string;
  p: string;
  k: string;
  npkGains: number;
  monps: number;
  total: number;
}

export interface ProductProps {
  'Plant ID': string;
  'Plant City': string;
  Plant: string;
  'Brand ID': number;
  Brand: string;
  'Product ID': number;
  'GIN Index': string;
  'Product Name': string;
  Application: string;
  'Packaging': string;
  'Prod.Class-Text ?': string;
  'Particle Size↵in um': string;
  'PIS ID': number;
  'PIS in the folder': string;
}

export interface PlantProps {
  'Plant ID': string;
  'Plant Name': string;
  Plant: string;
  Longitude: string;
  Lattitude: number;
  'Truck Y/N': string;
  'Train Y/N': string;
  'Boat Y/N': string;
}

export interface ProductPlantProps extends ProductProps, PlantProps {
}

export type TypeOfKey<T> = T[keyof T];

export type setStateType<T> = (callback: ((values: Partial<T>) => Partial<T>) | T) => void;

export type ReducerAction<S extends string = string> = {
  type: S;
  payload?: any;
};

export enum Country {
  Germany = 'Germany',
}

export enum CropTypes {
  Grassland = 'Grünland',
  OtherCrops = 'Other Crops',
}

export enum SoilTypes {
  'Sand' = 'Sand',
  'Sandiger Schl Lehm' = 'Sandiger Schl Lehm',
  'Schwach Lehm Sand' = 'Schwach Lehm Sand',
  'Stark Lehm Sand' = 'Stark Lehm Sand',
  'Toniger Lehm b.Ton' = 'Toniger Lehm b.Ton',
}